/* eslint-disable */
export default {
  cancel: 'Cancel',
  close: 'Close',
  ok: 'OK',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"close"@#@ @source: @#@"Close"@#@
// @key: @#@"ok"@#@ @source: @#@"OK"@#@
